import { useFpB2bCartItemValues, type UseFpB2bCartItemValuesArgs } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-item-values'
import { type CartFormValues } from '@cart-services/zod-schema/cartFormSchema'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

export const useSyncCartItemValuesToForm = (args: UseFpB2bCartItemValuesArgs) => {
  const cartItemsValues = useFpB2bCartItemValues(args)
  const { setValue } = useFormContext<CartFormValues>()

  useEffect(function syncCartItemValuesToForm() {
    setValue('cartItems', cartItemsValues)
  }, [cartItemsValues, setValue])
}
